module.exports = __webpack_public_path__ + "img/wallet.1421f5a3.png";